import moment from "moment";
import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { BtnComponent } from "../../components/button";
import { PageDialogContent, PageDialogFooter } from "../../components/dialog";
import { InputField } from "../../components/reactHookFormFields/inputField";
import { Mask } from "../../components/reactHookFormFields/mask";
import { useGroupChatContext } from "../../context/groupchatContext";
import { convertPhoneNumberFromMask } from "../../helpers/utility";
import { useAddExternalProviderMutation } from "../../services/referralService";


const AddReferring = ({cancelAddReferringPopup}) => {


    const groupChatContext = useGroupChatContext();
    const {selectedChat} = useMemo(() => ({
        selectedChat: groupChatContext.selectedChat,
    }));

    const [addExternalProvider, {isLoading}] = useAddExternalProviderMutation();

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const onSubmitForm = async(values) => {

        const payload = {
            ...values,
            phonecell: values.phonecell ? convertPhoneNumberFromMask(values.phonecell) : ''
        };

        const res = await addExternalProvider(payload);
        if(res?.data?.code === 0){
            toast.success(res.data.msg);
            cancelAddReferringPopup({...res.data.data, ...payload})
        }
        else {
            toast.error(res?.data?.msg);
        }
    }

    return(
        <>
            <PageDialogContent contentCls="p-3 sm:p-4 md:px-6">
                <form id="add_referring_form" onSubmit={handleSubmit(onSubmitForm)} className="min-w-0">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-4">
                        <div className="min-w-0">
                            <InputField
                                title="First Name"
                                name="fname"
                                control={control}
                                rules={{ required: { value: true } }}
                                errors={errors}
                            />
                        </div>
                        <div className="min-w-0">
                            <InputField
                                title="Last Name"
                                name="lname"
                                control={control}
                                rules={{ required: { value: true } }}
                                errors={errors}
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-2">
                        <div className="min-w-0">
                            <InputField
                                title="Email"
                                name="email"
                                type="email"
                                control={control}
                            />
                        </div>
                        <div className="min-w-0">
                            <Mask
                                mask="(999) 999-9999"
                                title="Phone"
                                name="phonecell"
                                showLableInline="true"
                                control={control}
                                rules={{
                                    pattern: {
                                        value: /^^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
                                        message: "Please Enter Correct Number",
                                    },
                                }}
                                errors={errors}
                            />
                        </div>
                    </div>
                </form>
            </PageDialogContent>
            <PageDialogFooter>
                <BtnComponent text="Cancel" btnType="default" onClick={cancelAddReferringPopup} />
                <BtnComponent text="Save" btnType='primary_theme' loading={isLoading} form="add_referring_form" type="submit" />
            </PageDialogFooter>
        </>
    )
}

export default AddReferring;